import { render } from "./modalFormMs.vue?vue&type=template&id=24a8582c"
import script from "./modalFormMs.vue?vue&type=script&lang=js"
export * from "./modalFormMs.vue?vue&type=script&lang=js"

import "./modalFormMs.vue?vue&type=style&index=0&id=24a8582c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__